import React from "react";
import { observer } from "mobx-react";
import styles from "./RequirementStep.module.scss";
import HelpMeItemContainer from "../../ui/HelpMeItemContainer/HelpMeItemContainer";
import Selector from "../../ui/Selector/Selector";
import { useStores } from "../../../../hooks/mobx";
import { BLOOD_CLASES, SHORT_BLOOD_GROUPS_HELP_ME } from "../../../../entities";
import InputRangeSelector from "../../ui/InputRangeSelector/InputRangeSelector";
import ListPicker from "../../ui/ListPicker/ListPicker";
import DateSelector from "../../ui/DateSelector/DateSelector";
import { addDays } from "../../../../utils/misc";

const RequirementStep = observer(() => {
  const { helpMeStore } = useStores();
  const {
    onChange,
    currentModel,
    currentModelErrors,
    currentModelInputData,
    onChangeMultiple,
    changeCityOptionsFilter,
    cityOptions,
    updateCityOptions,
    bloodStationOptions,
    updateBloodStationOptions,
    setBloodStationOptions,
  } = helpMeStore;

  const maxRequirementDate = () => {
    return addDays(new Date(), 10);
  };

  const minRequirementDate = () => {
    return addDays(new Date(), 2);
  };

  const onSelectCity = (item) => {
    onChange("city", item);
    if (item) updateBloodStationOptions(item);
    else setBloodStationOptions([]);
    onChange("blood_station", null);
  };

  return (
    <div className={styles.RequirementStep}>
      <div className={styles.RequirementStep_SplitByPercentContainer}>
        <HelpMeItemContainer
          title={"Компонент крови"}
          subTitle={"Выберите один необходимый компонент крови"}
          required={currentModelInputData["blood_class"].required}
          id={"blood_class"}
        >
          <Selector
            arrayOfObjects={BLOOD_CLASES}
            value={currentModel["blood_class"]}
            error={currentModelErrors["blood_class"]}
            onChange={(value) => onChange("blood_class", value)}
            maxColumns={5}
          />
        </HelpMeItemContainer>
      </div>
      <div
        className={styles.RequirementStep_SplitByHalfContainer}
        id={"requested_blood_type"}
      >
        <HelpMeItemContainer
          title={"Группа крови"}
          subTitle={
            "Выберите одну или несколько необходимых групп крови. В случае если подходит любая группа крови - выберите все  "
          }
          required={currentModelInputData["requested_blood_type"].required}
        >
          <Selector
            arrayOfObjects={SHORT_BLOOD_GROUPS_HELP_ME}
            value={currentModel["requested_blood_type"]}
            multiple
            error={currentModelErrors["requested_blood_type"]}
            onChangeMultiple={(value) =>
              onChangeMultiple("requested_blood_type", value)
            }
            maxColumns={4}
            centered
          />
        </HelpMeItemContainer>
      </div>
      <HelpMeItemContainer
        title={"Количество доноров"}
        required={currentModelInputData["required_donors_count"].required}
        id={"required_donors_count"}
      >
        <InputRangeSelector
          min={1}
          max={10}
          step={1}
          value={currentModel["required_donors_count"]}
          onChange={(value) => onChange("required_donors_count", value)}
        />
      </HelpMeItemContainer>
      <div className={styles.RequirementStep_DoubleCityContainer} id={"city"}>
        <HelpMeItemContainer
          title={"Город"}
          required={currentModelInputData["city"].required}
        >
          <ListPicker
            itemOptions={cityOptions}
            getUpdatedItems={updateCityOptions}
            placeholder={"Выберите город"}
            selectedValue={currentModel["city"]}
            onSelect={onSelectCity}
            onInputChange={changeCityOptionsFilter}
            error={currentModelErrors["city"]}
          />
        </HelpMeItemContainer>
      </div>
      <HelpMeItemContainer
        title={"Центр крови"}
        required={currentModelInputData["blood_station"].required}
        id={"blood_station"}
      >
        <ListPicker
          itemOptions={bloodStationOptions}
          disabled={!bloodStationOptions?.length}
          placeholder={currentModelInputData["blood_station"].placeholder}
          selectedValue={currentModel["blood_station"]}
          onSelect={(item) => onChange("blood_station", item)}
          error={currentModelErrors["blood_station"]}
          noNotFound={true}
        />
      </HelpMeItemContainer>
      <div
        className={styles.RequirementStep_DoubleContainer_DatePickerContainer}
      >
        <HelpMeItemContainer
          title={"Дата окончания поиска доноров"}
          required={currentModelInputData["last_date"].required}
          id={"last_date"}
          extraPaddings
        >
          <DateSelector
            maxDate={maxRequirementDate()}
            minDate={minRequirementDate()}
            value={currentModel["last_date"]}
            placeholder={currentModelInputData["last_date"].placeholder}
            error={currentModelErrors["last_date"]}
            onChange={(value) => onChange("last_date", value)}
          />
        </HelpMeItemContainer>
      </div>
    </div>
  );
});

export default RequirementStep;
